import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./ManageCookiesModal.css";
import { updateGTMConsent } from "@/utils/analytics";

const ManageCookiesModal = ({
  show,
  userId,
  visitorId,
  handleClose,
  onRejectOptional,
  onSavePreferences,
  marketingCookies,
  performanceCookies,
  handleCookieTypeChange,
}) => {
  useEffect(() => {
    if (show) {
      updateGTMConsent({
        event_name: "user_selected_manage_cookies",
        ad_storage: marketingCookies ? "granted" : "denied",
        security_storage: "granted",
        analytics_storage: performanceCookies ? "granted" : "denied",
        functionality_storage: "granted",
        personalization_storage: marketingCookies ? "granted" : "denied",
        ad_personalization: marketingCookies ? "granted" : "denied",
        ad_user_data: marketingCookies ? "granted" : "denied",
      }, { visitorId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      className="manage-cookies-modal"
      // dialogClassName="modal-90w"
      contentClassName="modal-custom-radius"
    >
      <Modal.Header
        closeButton
        className="bg-white border-0 modal-custom-header"
      />

      <Modal.Body className="cookieInfo px-5">
        <h1 className="mb-2">Information on Cookies</h1>
        <p>
          Our website and applications use essential cookies to work properly.
          In addition, we would like to set: (i) optional "performance" cookies
          to collect anonymous site visitation and/or use data; and (ii)
          optional "marketing" cookies to help us understand which content is
          most valued by our visitors. By enabling our optional cookies, you can
          help us to provide a better experience for visitors like yourself. For
          more information about our personal data processing practices, see our{" "}
          <a
            href="https://www.altisource.com/Privacy-Policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary text-decoration-underline"
          >
            Privacy Policy
          </a>
          .
        </p>

        <h2 className="mt-4">Manage Consent Preferences</h2>

        {/* Essential Cookies */}
        <CookiePreference
          title="Essential Cookies"
          description="These are strictly necessary cookies and we use them to make our website work, for example by allowing users to access secure areas in the website. Essential cookies are always on and cannot be deactivated by the user. See the list of essential cookies"
          link="https://image-prod.hubzu.com/cookies/Hubzu-cookies-Essential_v1.pdf"
          alwaysActive
        />

        {/* Performance Cookies */}
        <CookiePreference
          isSwitch
          id="performanceCookies"
          checked={performanceCookies}
          onChange={(e) => handleCookieTypeChange(e, "_performance")}
          title="Performance Cookies"
          description="These allow us to count visits and traffic sources, and monitor which pages are visited more often. These cookies help us to screen and improve the website's health and performance. See the list of cookies"
          link="https://image-prod.hubzu.com/cookies/Hubzu-cookies-Performance_v1.pdf"
        />

        {/* Marketing Cookies */}
        <CookiePreference
          isSwitch
          id="marketingCookies"
          checked={marketingCookies}
          onChange={(e) => handleCookieTypeChange(e, "_marketing")}
          title="Marketing Cookies"
          description="These allow us to track users across different websites, create visitor profiles and target our advertising. See the list of marketing cookies"
          link="https://image-prod.hubzu.com/cookies/Hubzu-cookies-Marketing_v1.pdf"
        />
      </Modal.Body>
      <Modal.Footer className="d-flex flex-column bg-white border-0 px-5">
        <button
          className="cookie-confirm-button cookie-modal-button"
          onClick={onSavePreferences}
        >
          Confirm My Choices
        </button>
        <button
          className="w-100 cookie-reject-button cookie-modal-button"
          onClick={onRejectOptional}
        >
          Reject All Optional Cookies
        </button>
        <small className="cookie-disclaimer">
          Note: Rejecting all optional cookies may have a negative impact on the
          usability and functionalities of the site.
        </small>
      </Modal.Footer>
    </Modal>
  );
};

const CookiePreference = ({
  isSwitch,
  id,
  checked,
  onChange,
  title,
  description,
  link,
  alwaysActive,
  children,
}) => (
  <div className="border rounded p-3 mb-0 rounded-0 cookieType-wrapper">
    <div className="cookieType-head">
      <h3>{title}</h3>
      {alwaysActive ? (
        <span className="text-primary bold">Always Active</span>
      ) : (
        children
      )}
      {isSwitch && <Switch id={id} checked={checked} onChange={onChange} />}
    </div>
    <p className="mb-1 mx-3">
      {description}{" "}
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary text-decoration-underline"
      >
        here
      </a>
      .
    </p>
  </div>
);

const Switch = ({ id, checked, onChange }) => (
  <div className="form-check form-switch">
    <input
      className="form-check-input modal-form-input-check"
      type="checkbox"
      id={id}
      checked={checked}
      onChange={onChange}
      aria-label="cookiee"
    />
  </div>
);

export default ManageCookiesModal;
